'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var AdvancedHepModalGridValidationService = function AdvancedHepModalGridValidationService(configurationService, AdvancedHepGridConstants, featureToggleService, advancedHepCommonValidationService) {
  var CABIN_CAPACITIES_FIELD_PREFIX = 'cabinCapacities';
  var INPUT_SOURCE_TYPES = {
    'ATPCO': ['BASE FARE', 'Q', 'QK'],
    'GDS': ['BASE FARE', 'YQ', 'YR', 'OTHER'],
    'WEB': ['BASE FARE', 'YQ', 'YR', 'OTHER']
  };
  var MAX_LOS_RANGES = 5,
    MIN_LOS_START = 0,
    MAX_LOS_END = 330;
  function getCabinCapacitiesFieldName(cabin) {
    return CABIN_CAPACITIES_FIELD_PREFIX + '-' + cabin;
  }
  function hasDuplicateEntryForTripTypeAndSource(newEntry, entry, field1, field2) {
    var newEntryValues = _.split(newEntry[field1], ',');
    var existingEntryValues = _.split(entry[field1], ',');
    var newEntryValues1 = _.split(newEntry[field2], ',');
    var existingEntryValues1 = _.split(entry[field2], ',');
    if (_.intersection(newEntryValues, existingEntryValues).length > 0) {
      return _.intersection(newEntryValues1, existingEntryValues1).length > 0;
    }
    return false;
  }
  function validateCurtainRuleModal(editedRows, allRows) {
    var isValid = true;
    var availableCabins = configurationService.getCabins();
    var lowestCabin = _.last(availableCabins);
    var higherCabin;
    _.forEach(allRows, function (row) {
      _.forEach(availableCabins, function (cabinName) {
        if (!_.isNil(row[getCabinCapacitiesFieldName(cabinName)]) && row[getCabinCapacitiesFieldName(cabinName)] !== '') {
          if (cabinName !== lowestCabin) {
            higherCabin = cabinName;
          }
        }
      });
    });
    _.forEach(editedRows, function (row) {
      var count = 0;
      _.forEach(availableCabins, function (cabinName) {
        if (!_.isNil(row[getCabinCapacitiesFieldName(cabinName)]) && row[getCabinCapacitiesFieldName(cabinName)] !== '') {
          if (cabinName !== higherCabin && cabinName !== lowestCabin) {
            isValid = false;
            toastr.error('Please enter only one other cabin other than the lowest cabin');
            return isValid;
          }
          count++;
        }
      });
      if (count < 2 && isValid) {
        isValid = false;
        toastr.error('Please enter values for at least two cabins');
        return isValid;
      }
    });
    return isValid;
  }
  function validateTodHubBanksModal(gridData) {
    var seqMap = _.keyBy(gridData, 'timeBandSequence');
    if (gridData.length === 0) {
      toastr.error('At least one bank is required');
      return false;
    }
    if (_.size(seqMap) !== gridData.length) {
      toastr.error('Duplicated banks');
      return false;
    }

    // 1+2+...+n == (n*(n+1))/2
    if (_.sumBy(gridData, 'timeBandSequence') !== gridData.length * (gridData.length + 1) / 2) {
      toastr.error('Banks must be continuous numbers that start with 1');
      return false;
    }
    if (seqMap[1].start !== 0) {
      toastr.error('First bank must start with 0');
      return false;
    }
    if (seqMap[gridData.length].end !== 1440) {
      toastr.error('The last bank must end with 1440');
      return false;
    }
    for (var i = 2; i <= gridData.length; i++) {
      if (seqMap[i - 1].end + 1 !== seqMap[i].start) {
        toastr.error('Overlapping or non-continuous banks');
        return false;
      }
    }
    return true;
  }
  var validateMetroMarketModal = function validateMetroMarketModal(editedRows, gridData) {
    var isValid = true;
    var columnsToCheck = ['neighborMarketOrigin', 'neighborMarketDestination'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, gridData, columnsToCheck)) {
        isValid = false;
        toastr.error('Duplicate row added for Origin and Destination');
      }
    });
    return isValid;
  };
  function isCompetitorFareBrandInvalid(row) {
    return !_.isNil(row.competitorFareBrand) && !_.isEmpty(row.competitorFareBrand) && _.intersection(getCompetitorFareBrands(row.benchmarkCarrier), _.split(row.competitorFareBrand, ',')).length !== _.split(row.competitorFareBrand, ',').length;
  }
  function validateFOBusinessRulesModal(editedRows, allRows) {
    var isValid = true;
    _.forEach(editedRows, function (row) {
      if ((_.isEmpty(row.hostFareBrand) || _.isNil(row.hostFareBrand)) && !_.isNil(row.competitorFareBrand) && !_.isEmpty(row.competitorFareBrand)) {
        isValid = false;
        toastr.error('Host Fare Brand is missing');
      }
      if (!_.isNil(row.fareTypeIndicator) && _.includes(row.fareTypeIndicator, 'OWNC') && row.normalizationIndicator === true) {
        isValid = false;
        toastr.error('Normalization not allowed for OWNC');
      }
      if (isCompetitorFareBrandInvalid(row)) {
        isValid = false;
        toastr.error('Selected competitor fare brands are not applicable for ' + advancedHepCommonValidationService.constructKey(row, AdvancedHepGridConstants.FO_BUSINESS_RULE_KEY_VALUES));
      }
    });

    //group by Orig-Dest-Season-BenchmarkCarrier
    var businessRuleKeyValues = _.groupBy(allRows, function (row) {
      return advancedHepCommonValidationService.constructKey(row, AdvancedHepGridConstants.FO_BUSINESS_RULE_KEY_VALUES);
    });
    //check that none of key fields overlap
    for (var key in businessRuleKeyValues) {
      if (areBusinessRuleFieldsOverlapping(businessRuleKeyValues[key], key)) {
        isValid = false;
      }
    }
    return isValid;
  }
  function getCompetitorFareBrands(benchmarkCarrier) {
    return _.transform(configurationService.getFoFareBrandDefinitions(), function (result, current) {
      if (!_.isNil(benchmarkCarrier) && current.carrier === benchmarkCarrier) {
        _.forEach(_.chain(current.fareBrands).map('fareBrand').value(), function (fareBrand) {
          result.push(fareBrand);
        });
      }
    });
  }
  function areBusinessRuleFieldsOverlapping(entries, key) {
    var areFieldsOverlapping = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = _.split(advancedHepCommonValidationService.constructKey(entries[i], AdvancedHepGridConstants.FO_BUSINESS_RULE_OVERLAPPING_FIELD_VALUES), '.');
          var to = _.split(advancedHepCommonValidationService.constructKey(entries[j], AdvancedHepGridConstants.FO_BUSINESS_RULE_OVERLAPPING_FIELD_VALUES), '.');
          if (_.intersection(_.split(from[0], ','), _.split(to[0], ',')).length > 0 && _.intersection(_.split(from[1], ','), _.split(to[1], ',')).length > 0 && _.intersection(_.split(from[2], ','), _.split(to[2], ',')).length > 0 && _.intersection(_.split(from[3], ','), _.split(to[3], ',')).length > 0 && _.intersection(_.split(from[4], ','), _.split(to[4], ',')).length > 0) {
            toastr.error('Duplicate rows identified for ' + key);
            areFieldsOverlapping = true;
          }
        }
      }
    }
    return areFieldsOverlapping;
  }
  function validateFOTaxOverride(editedRows, allRows) {
    var isValid = true;
    var columnsToCheck = ['fareType', 'fareTypeIndicator'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, allRows, columnsToCheck)) {
        toastr.error('Duplicate row added for fare type indicator and Tax/Surcharge Type.');
        isValid = false;
      }
    });
    return isValid;
  }
  function validateFOCabinClassConfig(gridData) {
    var tacticalClassName = _.compact(_.chain(gridData).map(function (group) {
      if (group.category === 'TACTICAL') {
        return group.className.toUpperCase();
      }
    }).value());
    if (_.uniq(tacticalClassName).length !== tacticalClassName.length) {
      toastr.error('Class Name for Tactical Category must be unique.');
      return false;
    }
    var structuralClassName = _.compact(_.chain(gridData).map(function (group) {
      if (group.category === 'STRUCTURAL') {
        return group.className.toUpperCase();
      }
    }).value());
    if (_.uniq(structuralClassName).length !== structuralClassName.length) {
      toastr.error('Class Name for Structural Category must be unique.');
      return false;
    }
    var duplicateCabinIndex = _.chain(gridData).map(function (group) {
      return [group.foCabin.toUpperCase(), group.cabinIndex];
    }).flatten().uniq().value().length;
    if (duplicateCabinIndex % 2 !== 0) {
      toastr.error('Cabin and Cabin Index must be unique.');
      return false;
    }
    var classIndexArrayLength = _.chain(gridData).map(function (group) {
      return group.classIndex;
    }).flatten().uniq().value().length;
    if (classIndexArrayLength !== gridData.length) {
      toastr.error('Class Index must be unique.');
      return false;
    }
    return true;
  }
  function validateFORBDLevelFareThreshold(editedRows, gridData) {
    var isValid = true;
    if (containsDuplicateRBDFareThresholdProperty(gridData)) {
      isValid = false;
      toastr.error('Duplicate row added for fare type indicator and rbd.');
    }
    _.forEach(editedRows, function (editedRow) {
      if (_.includes(editedRow, 'minFareThreshold') && _.isNil(editedRow.minFareThreshold) && _.isNil(editedRow.minFareThresholdPercent) || _.isNil(editedRow.maxFareThreshold) && _.isNil(editedRow.maxFareThresholdPercent)) {
        toastr.error('Fare Thresholds are not added');
        isValid = false;
      }
    });
    return isValid;
  }
  function containsDuplicateRBDFareThresholdProperty(gridData) {
    var tripTypeAndRbd = [];
    _.forEach(gridData, function (row) {
      _.forEach(row.fareTypeIndicator.split(','), function (tripType) {
        tripTypeAndRbd.push(row.foRbd + tripType);
      });
    });
    return new Set(tripTypeAndRbd).size !== tripTypeAndRbd.length;
  }
  function validateFareClassMapping(editedRows, gridData) {
    var isValid = true;
    _.forEach(editedRows, function (row) {
      if ((_.isEmpty(row.hostFareBrand) || _.isNil(row.hostFareBrand)) && !_.isNil(row.competitorFareBrand) && !_.isEmpty(row.competitorFareBrand)) {
        isValid = false;
        toastr.error('Host Fare Brand is missing');
      }
      if (isFareClassMappingCompetitorFareBrandInvalid(row)) {
        isValid = false;
        toastr.error('Selected competitor fare brands are not applicable for ' + row.competitorAirline);
      }
      var regExp = 'WEB' === row.fareSource.toUpperCase() ? /^[A-Z](,[A-Z])*$|^-$/i : /^[A-Z](,[A-Z])*$/i;
      if (!regExp.test(row.competitorEntryLevelRbds)) {
        isValid = isValid && false;
        toastr.error('Competitor rbd value should be comma separated uppercase alplabets or can be - for web source');
      }
    });
    var fareClassMappingKeyValues = _.groupBy(gridData, function (row) {
      return advancedHepCommonValidationService.constructKey(row, AdvancedHepGridConstants.FO_FARE_CLASS_MAPPING_KEY_VALUES);
    });
    for (var key1 in fareClassMappingKeyValues) {
      var groupingByInventoryAssignment = _.groupBy(fareClassMappingKeyValues[key1], 'inventoryAssignmentMethod');
      if (!_.isEmpty(groupingByInventoryAssignment)) {
        var entries = groupingByInventoryAssignment['ORDINAL'];
        if (isValid && !_.isEmpty(entries) && containsMultipleRowsForOrdinal(entries)) {
          isValid = false;
          toastr.error('For ORDINAL matching, Host RBDs should be same for same fare type, host fare brand and competitor carrier. ');
        }
      }
    }
    for (var key in fareClassMappingKeyValues) {
      if (isValid && areFareClassMappingFieldsOverlapping(fareClassMappingKeyValues[key])) {
        isValid = false;
      }
    }
    if (isValid && sameFareTypeContainsDifferentBenchmarkingMethod(gridData, 'inventoryAssignmentMethod')) {
      isValid = false;
      toastr.error('Inventory Assignment Method should be same for same fare type indicator.');
    }
    if (isValid && sameFareTypeContainsDifferentBenchmarkingMethod(gridData, 'ladderGenerationMethod')) {
      isValid = false;
      toastr.error('Ladder Generation Method should be same for same fare type indicator.');
    }
    return isValid;
  }
  function areFareClassMappingFieldsOverlapping(entries) {
    var areFieldsOverlapping = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = _.split(advancedHepCommonValidationService.constructKey(entries[i], AdvancedHepGridConstants.FO_FARE_CLASS_MAPPING_OVERLAPPING_FIELD_VALUES), '.');
          var to = _.split(advancedHepCommonValidationService.constructKey(entries[j], AdvancedHepGridConstants.FO_FARE_CLASS_MAPPING_OVERLAPPING_FIELD_VALUES), '.');
          if (_.intersection(_.split(from[0], ','), _.split(to[0], ',')).length > 0 && entries[i].hostEntryLevelRBD === entries[j].hostEntryLevelRBD && entries[i].fareSource === entries[j].fareSource && _.intersection(_.split(from[1], ','), _.split(to[1], ',')).length > 0) {
            toastr.error('Duplicate row added for competitor fare source, fare type indicator, host RBD, competitor airline and host fare brand. ');
            areFieldsOverlapping = true;
          }
        }
      }
    }
    return areFieldsOverlapping;
  }
  function containsMultipleRowsForOrdinal(entries) {
    var areFieldsOverlappingForOrdinal = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = _.split(advancedHepCommonValidationService.constructKey(entries[i], AdvancedHepGridConstants.FO_FARE_CLASS_MAPPING_OVERLAPPING_FIELD_VALUES), '.');
          var to = _.split(advancedHepCommonValidationService.constructKey(entries[j], AdvancedHepGridConstants.FO_FARE_CLASS_MAPPING_OVERLAPPING_FIELD_VALUES), '.');
          if (_.intersection(_.split(from[0], ','), _.split(to[0], ',')).length > 0 && _.intersection(_.split(from[1], ','), _.split(to[1], ',')).length > 0) {
            areFieldsOverlappingForOrdinal = true;
          }
        }
      }
    }
    return areFieldsOverlappingForOrdinal;
  }
  function sameFareTypeContainsDifferentBenchmarkingMethod(gridData, field) {
    var invalid = false;
    var fareTypeAndFieldMap = new Map();
    _.forEach(gridData, function (row) {
      var fareTypeIndicator = row.fareTypeIndicator.split(',');
      _.forEach(fareTypeIndicator, function (fareType) {
        if (fareTypeAndFieldMap.has(fareType)) {
          if (fareTypeAndFieldMap.get(fareType) !== row[field]) {
            invalid = true;
          }
        } else {
          fareTypeAndFieldMap.set(fareType, row[field]);
        }
      });
    });
    return invalid;
  }
  function validateMarketConfigModals(editedRows, gridData) {
    var isValid = true;
    if (featureToggleService.isEnabled('DYNAMIC_PRICING') && !_.isEmpty(gridData) && _.has(gridData[0], 'losStart')) {
      if (gridData.length > MAX_LOS_RANGES) {
        return false;
      }
      var sortedByStart = _.sortBy(gridData, 'losStart');
      if (sortedByStart[0].losStart !== MIN_LOS_START || sortedByStart[sortedByStart.length - 1].losEnd !== MAX_LOS_END) {
        return false;
      }
      isValid = validateLOSRangesToBeConsequent(sortedByStart);
    }
    if (featureToggleService.isEnabled('DYNAMIC_AVAILABILITY_ML_MODEL') && !_.isEmpty(gridData) && _.has(gridData[0], 'cabinCodeForMl')) {
      var cabins = _.map(gridData, 'cabinCodeForMl');
      isValid = isValid && cabins.length === _.uniq(cabins).length;
    }
    return isValid;
  }
  function validateLOSRangesToBeConsequent(sortedByStart) {
    var i = 0;
    for (var k = 1; k < sortedByStart - 1, i < sortedByStart.length - 1; k++) {
      if (sortedByStart[i].losEnd !== sortedByStart[k].losStart - 1) {
        return false;
      }
      i++;
    }
    return true;
  }
  function validateFareBrandAssignment(editedRows, gridData) {
    var isValid = true;
    var grouping = _.groupBy(gridData, function (gridRow) {
      return _.isEmpty(gridRow.inclusionFbcPattern) ? '' : gridRow.inclusionFbcPattern.toUpperCase();
    });
    if (containsDuplicateField(grouping, 'inclusionFbcPattern')) {
      isValid = false;
      toastr.error('Duplicate row added for Inclusion FBC Pattern');
    }
    _.forEach(editedRows, function (row) {
      if (_.isEmpty(row.fareBrand) || _.isNil(row.fareBrand)) {
        isValid = false;
        toastr.error('Fare Brand Cannot be empty');
      }
      if (_.isEmpty(row.inclusionFbcPattern) && _.isEmpty(row.exclusionFbcPattern) && _.isEmpty(row.ruleNumber)) {
        isValid = false;
        toastr.error('At least one value from Inclusion FBC Pattern, Exclusion FBC Pattern and Rule Number is required');
      }
    });
    var groupByInclusionFbcPattern = _.groupBy(gridData, function (gridRow) {
      return _.isEmpty(gridRow.inclusionFbcPattern) ? '' : gridRow.inclusionFbcPattern.toUpperCase();
    });
    _.forEach(_.keys(groupByInclusionFbcPattern), function (inclusionFbcPattern) {
      var groupByInclusionFbcPatternElement = groupByInclusionFbcPattern[inclusionFbcPattern];
      if (groupByInclusionFbcPatternElement.length > 1) {
        var groupByExclusionFbcPattern = _.groupBy(groupByInclusionFbcPatternElement, function (value) {
          return _.isEmpty(value.exclusionFbcPattern) ? '' : value.exclusionFbcPattern.toUpperCase();
        });
        _.forEach(_.keys(groupByExclusionFbcPattern), function (exclusionFbcPattern) {
          var groupByExclusionFbcPatternElement = groupByExclusionFbcPattern[exclusionFbcPattern];
          if (groupByInclusionFbcPatternElement.length > 1) {
            var groupByRuleNumber = _.groupBy(groupByExclusionFbcPatternElement, function (value) {
              return _.isEmpty(value.ruleNumber) ? '' : value.ruleNumber;
            });
            _.forEach(_.keys(groupByRuleNumber), function (ruleNumber) {
              var groupByRuleNumberElement = groupByRuleNumber[ruleNumber];
              if (groupByRuleNumberElement.length > 1) {
                isValid = false;
                toastr.error('Duplicate row identified with Inclusion FBC Pattern, Exclusion FBC Pattern or Rule Number');
              }
            });
          }
        });
      }
    });
    return isValid;
  }
  function validateTacticalFareDefinition(editedRows, gridData) {
    var isValid = true;
    /*var grouping = _.groupBy(gridData, function (gridRow) {
        return gridRow.inclusionFbcPattern.toUpperCase();
    });
    if (containsDuplicateField(grouping, 'inclusionFbcPattern')) {
        isValid = false;
        toastr.error('Duplicate row added for Inclusion FBC Pattern');
    }*/

    _.forEach(editedRows, function (row) {
      if (_.isEmpty(row.fareSource) || _.isNil(row.fareSource)) {
        isValid = false;
        toastr.error('Fare Source cannot be empty');
      }
      if (_.isEmpty(row.grouping) || _.isNil(row.grouping)) {
        isValid = false;
        toastr.error('Grouping cannot be empty');
      }
      if (_.isEmpty(row.criteriaType) || _.isNil(row.criteriaType)) {
        isValid = false;
        toastr.error('Criteria Type cannot be empty');
      }
      if (_.isEmpty(row.criteria) || _.isNil(row.criteria)) {
        isValid = false;
        toastr.error('Criteria cannot be empty');
      }
      if (_.isEmpty(row.operator) || _.isNil(row.operator)) {
        isValid = false;
        toastr.error('Operator cannot be empty');
      }
      if (_.isEmpty(row.value) || _.isNil(row.value)) {
        isValid = false;
        toastr.error('Value cannot be empty');
      }
      if ((_.isEmpty(row.compMatch) || _.isNil(row.compMatch)) && 'SECONDARY' === row.grouping.toUpperCase()) {
        isValid = false;
        toastr.error('Comp Match cannot be empty');
      }
      if ((!_.isEmpty(row.compMatch) || !_.isNil(row.compMatch)) && 'PRIMARY' === row.grouping.toUpperCase()) {
        //row.compMatch = null;
        //isValid = false;
        //toastr.error('Comp Match should be empty for Primary Grouping');
      }
      if (!_.isEmpty(row.grouping) && !_.isNil(row.grouping) && 'PRIMARY' === row.grouping.toUpperCase()) {
        if ('WEB' === row.fareSource.toUpperCase() && 'AMOUNT' !== row.criteriaType.toUpperCase() && 'DATE' !== row.criteriaType.toUpperCase() && 'RBD' !== row.criteriaType.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Criteria Type should be Amount or Date or RBD when fare Source is WEB and grouping is set to Primary');
        }
        if ('WEB' === row.fareSource.toUpperCase() && 'RBD' !== row.criteriaType.toUpperCase() && _.trim(row.operator) !== '<' && _.trim(row.operator) !== '=') {
          isValid = isValid && false;
          toastr.error('Operator should be < or = when fare source is WEB and grouping is set to Primary and Criteria Type is not RBD');
        }
      }
      if (!_.isEmpty(row.grouping) && !_.isNil(row.grouping) && 'SECONDARY' === row.grouping.toUpperCase()) {
        if ('WEB' === row.fareSource.toUpperCase() && 'DATE' !== row.criteriaType.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Criteria Type should be DATE when fare source is WEB and grouping is set to Secondary');
        } else if ('DATE' !== row.criteriaType.toUpperCase() && 'AP' !== row.criteriaType.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Criteria Type should be DATE or AP when fare source is ATPCO and grouping is set to Secondary');
        }
      }
      if ('AMOUNT' === row.criteriaType.toUpperCase()) {
        if ('WEB' !== row.fareSource.toUpperCase() || 'PRIMARY' !== row.grouping.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Fare source should be WEB and grouping should be set to Primary when Criteria Type is Amount');
        }
        if ('WEB' === row.fareSource.toUpperCase() && 'PRIMARY' === row.grouping.toUpperCase() && 'TOTAL FARE' !== row.criteria.toUpperCase() && 'BASE FARE' !== row.criteria.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Criteria should be Total Fare or Base Fare when fare source is WEB, grouping is set to Primary and Criteria Type is Amount');
        }
      }
      if ('DATE' === row.criteriaType.toUpperCase()) {
        if ('WEB' === row.fareSource.toUpperCase() && 'PRIMARY' === row.grouping.toUpperCase() && 'DEPARTURE DATE' !== row.criteria.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Criteria should be Departure Date when fare source is WEB and grouping is set to Primary and Criteria Type is Date');
        } else if (!_.split(_.trim(row.criteria), 'End Date').length > 1) {
          isValid = isValid && false;
          toastr.error('Criteria should be End Date when criteria Type is Date');
        }
      }
      if ('RBD' === row.criteriaType.toUpperCase()) {
        if (_.trim(row.criteria) !== 'RBD') {
          isValid = isValid && false;
          toastr.error('Criteria should be RBD when Criteria Type is set to RBD');
        }
        if (_.trim(row.operator) !== '=' && _.trim(row.operator) !== '!=') {
          isValid = isValid && false;
          toastr.error('Operator should be = or != when Criteria Type is set to RBD');
        }
      }
      if ('AP' === row.criteriaType.toUpperCase()) {
        if (_.trim(row.criteria) !== 'AP-Res' && _.trim(row.criteria) !== 'AP-Tkt') {
          isValid = isValid && false;
          toastr.error('Criteria should be AP-Res or AP-Tkt when Criteria Type is set to AP');
        }
      }
      if ('MMS' === row.criteriaType.toUpperCase()) {
        if (_.trim(row.criteria) !== 'Min Stay' && _.trim(row.criteria) !== 'Max Stay') {
          isValid = isValid && false;
          toastr.error('Criteria should be Min Stay or Max Stay when Criteria Type is set to MMS');
        }
      }
      var regExp = 'RBD' === row.criteriaType.toUpperCase() ? 'WEB' === row.fareSource.toUpperCase() ? /^[A-Z](,[A-Z])*$|^-$/i : /^[A-Z](,[A-Z])*$/i : /^[\d]+$/i;
      if (!regExp.test(row.value)) {
        isValid = isValid && false;
        toastr.error('Value should be comma separated uppercase alplabet or can be - for web source for RBD and digits for other types');
      }
      if ('TOTAL FARE' === row.criteria.toUpperCase() || 'BASE FARE' === row.criteria.toUpperCase()) {
        if ('WEB' !== row.fareSource.toUpperCase() || 'PRIMARY' !== row.grouping.toUpperCase() || 'AMOUNT' !== row.criteriaType.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Fare source should be WEB, grouping should be set to Primary and Criteria Type should be Amount when Criteria is Total Fare/Base Fare');
        }
      }
      if ('DEPARTURE DATE' === row.criteria.toUpperCase()) {
        if ('WEB' !== row.fareSource.toUpperCase() || 'PRIMARY' !== row.grouping.toUpperCase() || 'DATE' !== row.criteriaType.toUpperCase()) {
          isValid = isValid && false;
          toastr.error('Fare source should be WEB, grouping should be set to Primary and Criteria Type should be DATE when Criteria is Departure Date');
        }
      }
      if (areTacticalFareDefinitionsDuplicate(gridData)) {
        isValid = false;
      }
    });
    return isValid;
  }
  function areTacticalFareDefinitionsDuplicate(entries) {
    var areFieldsOverlapping = false;
    if (entries.length > 1) {
      for (var i = 0; i < entries.length - 1; i++) {
        for (var j = i + 1; j < entries.length; j++) {
          var from = entries[i];
          var to = entries[j];
          if (_.intersection(_.split(from['value'], ','), _.split(to['value'], ',')).length > 0 && from['fareSource'] === to['fareSource'] && from['grouping'] === to['grouping'] && from['criteriaType'] === to['criteriaType'] && from['criteria'] === to['criteria'] && from['compMatch'] === to['compMatch'] && from['operator'] === to['operator']) {
            toastr.error('Duplicate rows identified');
            areFieldsOverlapping = true;
          }
        }
      }
    }
    return areFieldsOverlapping;
  }
  function isFareClassMappingCompetitorFareBrandInvalid(row) {
    return !_.isNil(row.competitorFareBrand) && !_.isEmpty(row.competitorFareBrand) && _.intersection(getCompetitorFareBrands(row.competitorAirline), _.split(row.competitorFareBrand, ',')).length !== _.split(row.competitorFareBrand, ',').length;
  }
  function containsDuplicateField(grouping, field) {
    return _.find(_.values(grouping), function (array) {
      if (array.length > 1) {
        var fareBrandAssignments = _.chain(array).filter(function (o) {
          return !_.isEmpty(o[field]);
        }).map(function (o) {
          return o[field].toUpperCase();
        }).flatten().value();
        return new Set(fareBrandAssignments).size !== fareBrandAssignments.length;
      }
      return false;
    });
  }
  function validateAnalystPosMapping(editedRows, allRows) {
    var isValid = true;
    var columnsToCheck = ['level'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, allRows, columnsToCheck)) {
        toastr.error('Level should be unique.');
        isValid = false;
      }
    });
    return isValid;
  }
  function validateSeasonLevelMatchThreshold(editedRows, allRows) {
    var isValid = true;
    for (var i = 0; i < allRows.length; i++) {
      for (var j = i + 1; j < allRows.length; j++) {
        if (hasDuplicateEntryForTripTypeAndSource(allRows[i], allRows[j], 'fareTypeIndicator', 'fareSource')) {
          isValid = false;
        }
      }
    }
    if (!isValid) {
      toastr.error('Duplicate row added for fare type indicator and fare Source');
    }
    return isValid;
  }
  function isPropertiesOverlapped(editedRows, gridData, type, rangesProperties) {
    var result = false;
    if (editedRows !== undefined && editedRows.length > 0) {
      var ranges = _.isUndefined(rangesProperties) ? advancedHepCommonValidationService.getRangeTypes(type) : rangesProperties;
      if (type === 'FOAdvancePurchaseGrouping') {
        if (advancedHepCommonValidationService.isRangesAreOverlappingForAP(gridData, ranges)) {
          result = true;
        }
      } else {
        if (advancedHepCommonValidationService.isRangesAreOverlapping(gridData, ranges)) {
          result = true;
        }
      }
    }
    if (result) {
      toastr.error('Overlapping rows identified.');
    }
    return result;
  }
  function validateInputDataComparisonChecks(editedRows, gridData) {
    var isValid = true;
    var columnsToCheck = ['inputType', 'inputSource'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, gridData, columnsToCheck)) {
        isValid = false;
        toastr.error('Duplicate row added for Input Source and Input Type');
      }
    });
    _.forEach(editedRows, function (row) {
      if (_.isNil(row.absoluteChange) && _.isNil(row.percentageChange)) {
        isValid = false;
        toastr.error('Atleast one of Absolute/Percentage change must be defined for Input Source and Type.');
      }
    });
    _.forEach(editedRows, function (row) {
      if (isInvalidInputTypeForInputSource(row.inputSource, row.inputType)) {
        isValid = false;
        toastr.error(' Incorrect Input Type ' + row.inputType + ' for Input Source ' + row.inputSource);
      }
    });
    return isValid;
  }
  function isInvalidInputTypeForInputSource(inputSource, inputType) {
    return !INPUT_SOURCE_TYPES[inputSource].includes(inputType);
  }
  function validateRoutingNumberAndViaPoints(editedRows, allRows) {
    var areViaPointsValid = validateConnectionField(editedRows, allRows);
    var isValid = true;
    var columnsToCheck = ['routingNumber'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, allRows, columnsToCheck)) {
        toastr.error('Duplicate row added for same routing number');
        isValid = false;
      }
    });
    return isValid && areViaPointsValid;
  }
  function validateConnectionField(editedRows, allRows) {
    var isValid = true;
    for (var i = 0; i < allRows.length; i++) {
      for (var j = i + 1; j < allRows.length; j++) {
        if (hasDuplicateEntryForViaPoints(allRows[i], allRows[j], 'connectionInbound', 'connectionOutbound')) {
          isValid = false;
        }
      }
    }
    if (!isValid) {
      toastr.error('Duplicate row added for total fare hub definition');
    }
    return isValid;
  }
  function hasDuplicateEntryForViaPoints(newEntry, entry, field1, field2) {
    var newEntryValues = _.split(newEntry[field1], ',');
    var existingEntryValues = _.split(entry[field1], ',');
    var newEntryValues1 = _.split(newEntry[field2], ',');
    var existingEntryValues1 = _.split(entry[field2], ',');
    return isOverlappingConnectionField(newEntryValues, existingEntryValues) && isOverlappingConnectionField(newEntryValues1, existingEntryValues1);
  }
  function isOverlappingConnectionField(newEntryValues, existingEntryValues) {
    return newEntryValues.length == existingEntryValues.length && newEntryValues.sort().every(function (element, index) {
      return element === existingEntryValues.sort()[index];
    });
  }
  function validateFareBrandAssignmentModal(editedRows, gridData) {
    var configs = _.map(gridData, function (row) {
      return row.fareBrandConfiguration + row.inclusionFbcPattern + row.exclusionFbcPattern;
    });
    return configs.length === _.uniq(configs).length;
  }
  function validateTacticalFBCPatternConfig(editedRows, allRows) {
    var isValid = true;
    var columnsToCheck = ['fareSource', 'position', 'include', 'exclude'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, allRows, columnsToCheck)) {
        isValid = false;
        toastr.error('Duplicate row added');
      }
    });
    return isValid;
  }
  function validateSurchargeManagement(editedRows, allRows) {
    var isValid = true;
    var columnsToCheck = ['surchargeType'];
    _.forEach(editedRows, function (row) {
      if (advancedHepCommonValidationService.isDuplicate(row, allRows, columnsToCheck)) {
        isValid = false;
        toastr.error('Duplicate row added for same surcharge Type');
      }
    });
    return isValid;
  }
  function areModalColumnValidationsFulfilled(editedRows, gridData, type) {
    switch (type) {
      case 'CurtainRule':
        return validateCurtainRuleModal(editedRows, gridData);
      case 'FP_TOD_HubBank':
        return validateTodHubBanksModal(gridData);
      case 'FP_MetroMarket':
        return validateMetroMarketModal(editedRows, gridData);
      case 'FOBusinessRules':
        return validateFOBusinessRulesModal(editedRows, gridData);
      case 'FOTaxOverride':
        return validateFOTaxOverride(editedRows, gridData);
      case 'FOCabinClassConfig':
        return validateFOCabinClassConfig(gridData);
      case 'FOMinStayGrouping':
        return !isPropertiesOverlapped(editedRows, gridData, type);
      case 'FOMaxStayGrouping':
        return !isPropertiesOverlapped(editedRows, gridData, type);
      case 'FOAdvancePurchaseGrouping':
        return !isPropertiesOverlapped(editedRows, gridData, type);
      case 'FORBDLevelFareThreshold':
        return validateFORBDLevelFareThreshold(editedRows, gridData);
      case 'FOFareClassMapping':
        return validateFareClassMapping(editedRows, gridData);
      case 'FOAnalystPosMapping':
        return validateAnalystPosMapping(editedRows, gridData);
      case 'FOSeasonLevelMatchThreshold':
        return validateSeasonLevelMatchThreshold(editedRows, gridData);
      case 'FOFareBrandAssignment':
        return validateFareBrandAssignment(editedRows, gridData);
      case 'FP_MarketConfig':
        return validateMarketConfigModals(editedRows, gridData);
      case 'FOViaPoints':
        return validateRoutingNumberAndViaPoints(editedRows, gridData);
      case 'FOInputDataComparisonChecks':
        return validateInputDataComparisonChecks(editedRows, gridData);
      case 'FOTacticalFareDefinition':
        return validateTacticalFareDefinition(editedRows, gridData);
      case 'DA_FareBrandAssignment':
        return validateFareBrandAssignmentModal(editedRows, gridData);
      case 'FOTacticalFBCPatternConfig':
        return validateTacticalFBCPatternConfig(editedRows, gridData);
      case 'FOSurchargeManagement':
        return validateSurchargeManagement(editedRows, gridData);
    }
    return true;
  }
  return {
    areModalColumnValidationsFulfilled: areModalColumnValidationsFulfilled
  };
};
AdvancedHepModalGridValidationService.$inject = ['ConfigurationService', 'AdvancedHepGridConstants', 'FeatureToggleService', 'AdvancedHepCommonValidationService'];
module.exports = AdvancedHepModalGridValidationService;